import { MessageNotifBannerService, MessageType, MessageBanner } from './message-notif-banner.service';
import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-message-notif-banner',
    templateUrl: './message-notif-banner.component.html',
    styleUrls: ['./message-notif-banner.component.scss']
})
export class MessageNotifBannerComponent implements OnInit {

    message: string;
    classStyle: string;
    constructor(private notifService: MessageNotifBannerService) { }

    ngOnInit() {
        this.notifService.getMessage().subscribe((msg: MessageBanner) => {
            if (msg) {
                this.message = msg.message;
                this.classStyle = msg.type;
            }
        });
    }
}
